<div class="dialog" *ngIf="strategyWasChanged.modalOpened">
  <div class="dialog-background" (click)="closeModal()"></div>
  <div class="dialog-content">
    <img (click)="closeModal()" class="close" src="/assets/images/close.svg" alt="close" width="16px" height="16px" />
    <h2>{{ 'new_strategy.save_mode.h2' | translate }}</h2>
    <div class="ui-button-group reverse">
      <button (click)="discardChanges()" class="ui-button secondary">{{ 'new_strategy.save_mode.cancel' | translate }}</button>
      <button (click)="saveChanges()" class="ui-button" [disabled]="!enableSaveButton">
        {{ 'new_strategy.save_mode.cta' | translate }}
      </button>
    </div>
  </div>
</div>
